import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { Task } from '../../model/task/task';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  constructor(
    private client: HttpClient,
  ) { }

  getAllTasksForProject(projectId: string): Promise<Task[]> {
    return firstValueFrom(this.client.get<Task[]>(`/api/v1/projects/${projectId}/task`));
  }

  getAllTasksForUser(): Promise<Task[]> {
    return firstValueFrom(this.client.get<Task[]>(`/api/tasks`));
  }

  updateTask(task: Task) {
    return firstValueFrom(this.client.put<Task>('api/tasks/' + task.id, task))
  }

  addTask(task: Task) {
    return firstValueFrom(this.client.post<Task>('api/tasks', task))
  }
}
